import { render } from "./ModalDialogQuestion.vue?vue&type=template&id=7fc81d03"
import script from "./ModalDialogQuestion.vue?vue&type=script&lang=js"
export * from "./ModalDialogQuestion.vue?vue&type=script&lang=js"

import "./ModalDialogQuestion.vue?vue&type=style&index=0&id=7fc81d03&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__